import { styled, theme } from '../../../theme'

interface props {
  isResponsiveStyling?: boolean
}

export const HomePageContainer = styled.div<props>`
  .ant-page-header {
    background-color: ${(props) => props.theme.colors.grayBackground};
    padding: 16px 0 4px 0;
  }

  .ant-page-header-heading-extra {
    width: ${(props) => (props.isResponsiveStyling ? '100%' : null)};
  }

  .ant-space-align-center {
    width: ${(props) => (props.isResponsiveStyling ? '100%' : null)};
  }

  .ant-space-align-center > .ant-space-item {
    width: ${(props) => (props.isResponsiveStyling ? '100%' : null)};
  }

  .card {
    background: ${(props) => props.theme.colors.beightWhite};
    box-shadow: 0px 4px 17px rgba(0, 0, 0, 0.07);
    border-radius: 5px;
    overflow: hidden;
    height: 100%;
    max-height: 128px;
  }

  .card .ant-card-head-title {
    font-family: 'Akkurat LL Regular', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
      'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 20px;
    font-style: normal;
    opacity: 0.6;
    white-space: normal;
  }

  .ant-card-head {
    border-bottom: 0;
    padding: 0 20px;
  }

  .active-count {
    margin: 0 12px;
    transform-origin: left;
  }

  .no-icon-card {
    margin: 0 !important;
  }

  .card .ant-card-body {
    padding: 0 20px;
  }

  .station-overview-meta-container span {
    opacity: 0.6;
  }

  .station-overview-meta-container p:nth-of-type(2) {
    margin-left: 10px;
  }

  .station-overview-meta-container {
    display: flex;
    align-content: space-between;
    justify-content: start;
    align-items: baseline;
    flex-direction: row;
  }

  section {
    margin: 2px 15px;
  }

  .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list,
  .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-list {
    justify-content: ${(props) => (props.isResponsiveStyling ? 'center' : 'flex-end')};
    height: fit-content;
  }

  .ant-tabs-tab {
    padding: ${(props) => (props.isResponsiveStyling ? '0px' : '3px')};
  }

  .ant-tabs-tab-btn {
    padding: ${(props) => (props.isResponsiveStyling ? '7.5px 15px' : '7.5px 20px')};
  }

  .utlization-insight {
    margin-top: 20px;
  }

  .ant-picker.ant-picker-range {
    width: ${(props) => (props.isResponsiveStyling ? '100%' : '')};
  }

  .ant-tabs > .ant-tabs-nav,
  .ant-tabs > div > .ant-tabs-nav {
    flex-direction: ${(props) => (props.isResponsiveStyling ? 'column' : 'row')};
  }

  .ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap,
  .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap {
    justify-content: ${(props) => (props.isResponsiveStyling ? 'center' : 'flex-end')};
    align-items: center;
  }

  .utlization-insight-tabs.consumption > .ant-tabs-nav {
    padding: '20px';
  }

  .consumption-insight-tabs > .ant-tabs-nav {
    position: absolute;
    top: -70px;
    right: 0px;
  }

  .station-activation .ant-btn.ant-btn-primary {
    /* background-color: white;
    color: black;
    border: 1px solid #dedede; */

    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: space-between;
    flex-wrap: nowrap;
    flex-direction: row;
  }

  .station-activation svg {
    margin-left: 5px;
  }

  .ant-picker-panels {
    min-width: 700px;
    display: flex;
    justify-content: end;
  }

  .ant-picker-footer {
    position: absolute;
    top: 50%;
    display: flex;
  }

  .ant-picker-ranges {
    display: flex;
    flex-direction: column;
  }

  /* .trnx-btn span {
    font-family: 'AkkuratLLWeb-Regular';
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
  } */

  .trnx-btn {
    padding: ${(props) => (props.isResponsiveStyling ? '9px' : '10px 50px')};
    background-color: ${theme.colors.beightWhite};
    border: 1px solid ${theme.colors.cultered};
    letter-spacing: 0.05em;
  }

  .trnx-btn:active {
    background-color: ${theme.colors.ternary25};
    border: 1px solid ${theme.colors.lightGray};

    span {
      opacity: 15%;
    }
  }

  .ghg-savings .ant-card-extra {
    padding-bottom: 0;
    padding-top: 10px;
  }

  .connectors-plugged-in-meta-container {
    margin-top: 29px;
  }

  .ant-tabs-tab-btn {
    padding: ${(props) => (props.isResponsiveStyling ? '7.5px 12px' : '7.5px 20px')};
  }

  .ant-tabs.ant-tabs-top.utlization-insight-tabs-2 {
    /* position: absolute; */
    /* top: 0px;
    left: 0;
    right: 0; */
    margin: 0 auto;
  }

  .ant-tabs.ant-tabs-top.utlization-insight-tabs-2 .ant-tabs-nav-wrap {
    justify-content: center;
  }

  .chargers-availability h1.active-count.heading-02-black.laptop-active {
    /* font-size: 2em; */
  }

  .chargers-availability h1.active-count.heading-02-black.laptop-active-small {
    /* font-size: 1.5em; */
  }

  .chargers-availability.laptop-active .station-overview-meta-container {
    /* position: absolute;
    top: 5px; */
  }

  .chargers-availability.laptop-active .connectorsAvailability {
    top: 0px;
  }

  .ant-empty {
    margin: 32px auto;
  }

  .empty-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .empty-consumption-container .ant-tabs-content-holder {
    min-height: 309px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .empty-utilization-insight-container .ant-tabs-content-holder {
    min-height: 400px;
  }

  .ant-tabs.ant-tabs-top.utlization-insight-tabs-2 {
    margin-top: 0px;
  }

  .empty-utilization-insight-container .ant-tabs-content-holder,
  .empty .ant-tabs-content-holder {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .active-users-meta-container {
    align-items: center;
  }

  .ant-select {
    width: ${(props) => (props.isResponsiveStyling ? null : '272px !important')};
  }
`

export const MetricsWrapper = styled.div`
  .ant-card {
    min-height: 170px;
  }

  .paragraph-04-regular span:nth-of-type(2) {
    opacity: 0.6;
    margin-left: 5px;
  }

  .ghg-savings .paragraph-04-regular span {
    opacity: 0.6;
  }
`

export const StationOverviewMetaContainer = styled.div`
  display: flex;
  align-content: space-between;
  justify-content: start;
  align-items: center;
  flex-direction: row;
  overflow: hidden;

  .stretch {
    flex: 1;
  }

  .active-count {
    margin: 0 12px;
    transform-origin: left;
  }
  .suffix {
    display: flex;
    align-items: flex-end;
    transform-origin: left;
  }

  .suffix p {
    margin: 5px 8px;
    color: ${theme.colors.darkGray};
  }
`

export const StationOverviewMetaCountContainer = styled.div`
  display: flex;
  align-content: space-between;
  justify-content: start;
  align-items: baseline;
  flex-direction: column;
  margin: 21px auto;

  .info-area {
    display: flex;
    flex-direction: row;
  }

  .sublabel-area {
    flex: 1;
  }

  .paragraph-01-regular {
    margin: 0;
    padding: 0;
    position: relative;
  }

  .paragraph-01-regular.info-area.clickable {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  .default-label {
    color: ${(props) => props.theme.colors.darkGray};
  }

  .label-area.clickable {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  .label-area {
    margin-right: 5px;
  }

  .paragraph-01-regular:not(:first-of-type) {
    margin-top: 8px;
  }

  svg {
    position: absolute;
    right: -25px;
    bottom: 0px;
    cursor: pointer;
  }
`

export const MicroChartContainer = styled.div`
  width: 100%;
  height: 50px;
  minwidth: 0;
  overflow: hidden;
  display: flex;
  padding-right: 12px;
  opacity: 0;

  .highcharts-tooltip-box {
    fill: ${(props) => props.theme.colors.softBlack};
    display: block;
    border: none;
    stroke-width: 0;
  }
  .highcharts-tooltip text {
    fill: white;
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    height: 200px;
    color: white;
  }

  .highcharts-tooltip-container .highcharts-tooltip > span {
    min-width: 350px;
    width: 400px;
    min-height: 200px;
    color: white;
  }

  .highcharts-label.highcharts-tooltip.highcharts-color-0,
  .highcharts-label.highcharts-tooltip.highcharts-color-1,
  .highcharts-label.highcharts-tooltip.highcharts-color-2 {
    stroke: unset;
  }
`

export const UtilizationGaugeInfoContainer = styled.div`
  position: absolute;
  bottom: 30px;
  left: 0;
  width: 100%;
  /* transform: translateY(100%); */
`

export const HomePageUtilizationContainer = styled.div`
  position: relative;
  /* border-left: 1px solid rgb(222, 222, 222); */
  .utlization-gauge-info {
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: flex-start;
  }

  .utlization-gauge-info:nth-of-type(1) {
    margin-bottom: 10px;
  }

  .utlization-gauge-info,
  .utlization-gauge-info p {
    margin-left: 20px;
  }
`
export const UtlizationInsightContainer = styled.div`
  background: ${(props) => props.theme.colors.beightWhite};
  box-shadow: 0px 4px 17px rgba(0, 0, 0, 0.07);
  border-radius: 5px;
`

export const ConsumptionInsightContainer = styled.div`
  background: ${(props) => props.theme.colors.beightWhite};
  box-shadow: 0px 4px 17px rgba(0, 0, 0, 0.07);
  border-radius: 5px;
`

export const ConsumptionInsightMetaContainer = styled.div`
  overflow: hidden;
  .ant-card-head-title {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 16px 0 !important;
  }

  .ant-card-body {
    padding-bottom: 16px !important;
  }

  .ant-card-head {
    min-height: unset;
  }

  .ant-card {
    border-radius: 0 !important;
    box-shadow: unset;
  }

  .card {
    min-height: unset;
    border-radius: 0;
    box-shadow: unset;
    border: 0;
    border-bottom: 1px solid ${(props) => props.theme.colors.lightGray};
  }

  .ant-card-head-title {
    padding-bottom: 0;
  }

  p {
    opacity: 0.6;
    margin-left: 10px;
    margin-bottom: 0;
    color: ${(props) => props.theme.colors.grey10};
  }

  h3 {
    margin-bottom: 0;
  }

  /* sub {
    font-size: 12px;
    font-weight: normal;
  } */

  .ant-card-bordered {
    border: 0;
  }

  .show-border-bottom {
    border-bottom: 1px solid ${(props) => props.theme.colors.lightGray};
  }

  .ant-card-bordered.uniqueUsers,
  .ant-card-bordered.avgNumberOfTransactions,
  .ant-card-bordered.averageConsumption {
    border-bottom: 1px solid ${(props) => props.theme.colors.lightGray};
  }
`

export const HomePageStationActivationContainer = styled.div<props>`
  box-shadow: 0px 4px 17px rgb(0 0 0 / 7%);
  border-radius: 5px;
  background-color: ${(props) => props.theme.colors.white};
  overflow: hidden;
  min-height: 550px;
  flex: 1;
`
export const HomePageTransactionOverviewTableContainer = styled.div`
  box-shadow: 0px 4px 17px rgb(0 0 0 / 7%);
  border-radius: 5px;

  svg[data-icon='caret-up'],
  svg[data-icon='caret-down'] {
    fill: gray;
  }
`

export const DateContainer = styled.div`
  p {
    margin-bottom: 0;
  }

  p:nth-of-type(2) {
    opacity: 0.6;
  }
`
export const ChartContainer = styled.div`
  ${(props) => props.theme.breakpoints.down('xl')} {
    padding-bottom: 40px;
  }
`
export const ChargersAvailabilityMetaContainer = styled.div`
  /* margin: 42px auto 21px auto; */

  ${(props) => props.theme.breakpoints.up('xxl')} {
    margin: 21px auto;
  }
`

export const SectionGap = styled.div`
  height: 8px;
  background: ${theme.colors.black05};
  margin: 0px -20px 0px -20px;
`

export const RealTimeDataSectionWrapper = styled.div`
  padding-bottom: 24px;
`

export const HistoricalDataSectionWrapper = styled.div`
  padding-top: 24px;
`
